module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "Duplicate to which course(s)?",
      "size": "md_xl",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "h-full w-full px-6 pb-6 min-h-1/5 overflow-y-auto overflow-x-hidden"
  }, [_c('div', {
    staticClass: "h-full flex flex-col"
  }, [_c('div', {
    staticClass: "p-6 border-t border-r border-l border-solid border-gray-200 bg-gray-100 rounded-t-md",
    attrs: {
      "id": "header-information-course"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3",
    attrs: {
      "id": "select_course_component"
    }
  }, [_c('div', {
    staticClass: "bg-blueGray-700 rounded-full p-2.5"
  }, [_c('img', {
    staticClass: "h-4 w-4",
    attrs: {
      "src": "/static/roundtable_options_create/courses_icon.svg",
      "alt": "course_parlay"
    }
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-base text-blueGray-800 font-poppins font-semibold"
  }, [_vm._v("Select Course")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search_course"
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2 bg-white border border-solid border-gray-300 rounded-md w-64 px-3 py-1.5 focus-within:border-gray-400"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-400"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchCourse),
      expression: "searchCourse"
    }],
    staticClass: "w-full bg-white font-poppins font-light text-gray-700 focus-within:border-white border-white",
    attrs: {
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.searchCourse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchCourse = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-y-auto h-1 flex-grow rounded-b bg-gray-100 border-r border-b border-l border-gray-200 border-solid"
  }, [_c('ul', {
    staticClass: "px-6"
  }, [_vm._l((_vm.coursesFiltered), function(course, index) {
    return _c('li', {
      key: index,
      staticClass: "flex mb-2 justify-between bg-white px-5 py-3.5 rounded-md hover:border-primary border border-solid border-gray-200 cursor-pointer",
      class: {
        'border-primary': _vm.isCourseSelected(course.id) === true
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectCourse(course)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('h6', {
      staticClass: "hover:underline"
    }, [_vm._v(_vm._s(course.title))]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-1.5 text-gray-500 font-light"
    }, [_c('span', [_vm._v(_vm._s(course.sections[0]))])])]), _vm._v(" "), _c('Checkbox', {
      attrs: {
        "is_checked": _vm.isCourseSelected(course.id)
      }
    })], 1)
  }), _vm._v(" "), (_vm.coursesFiltered.length === 0 && _vm.loadingCourses === false) ? _c('div', {
    staticClass: "flex h-full flex-col items-center"
  }, [_vm._v("\n            No Courses are found\n          ")]) : _vm._e(), _vm._v(" "), (_vm.loadingCourses === true) ? _c('div', {
    staticClass: "h-full flex flex-col justify-center items-center"
  }, [_c('div', {
    staticClass: "flex justify-center items-center mb-2"
  }, [_c('pl-spinner')], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("Loading Courses")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bg-white mt-5"
  }, [_c('div', {
    staticClass: "flex items-center justify-start space-x-2 mb-5"
  }, [_c('Checkbox', {
    attrs: {
      "is_checked": _vm.isToCopyCriteria
    },
    on: {
      "input": function (value) { return _vm.isToCopyCriteria = value; }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins font-light text-gray-800"
  }, [_vm._v("Also copy assessment criteria to new course")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center space-x-1"
  }, [_c('button', {
    staticClass: "px-5 bg-white border border-solid border-gray-200 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-800 :hover:text-gray-900 font-medium disabled:opacity-50",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "text": _vm.getProfile.activity_passes + ' RoundTables left. Click to upgrade account.',
      "positionTooltip": "relative"
    }
  }, [(!_vm.getProfile.is_paid) ? _c('button', {
    staticClass: "inline-flex hover:text-gray-900 items-center justify-center border border-solid border-coolGray-200 w-10 h-10 text-gray-700 transition-colors duration-150 bg-coolGray-50 rounded focus:shadow-outline hover:bg-coolGray-100",
    on: {
      "click": function($event) {
        return _vm.handleClickUpgradeAccount()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-rocket text-base text-pinky"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [(_vm.isInformationVisible === false) ? _c('button', {
    staticClass: "cursor-pointer mr-4",
    on: {
      "click": function($event) {
        return _vm.handleOpenInformation()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-blueGray-700 hover:text-blueGray-800 text-base"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "flex bg-primary rounded font-medium px-4 py-2 hover:bg-primary-dark text-white disabled:opacity-50 disabled:cursor-not-allowed",
    attrs: {
      "disabled": _vm.selectedCourses.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.handleDuplicateRoundTable()
      }
    }
  }, [_vm._v("\n              Duplicate (" + _vm._s(_vm.selectedCourses.length) + ")\n              "), (_vm.isLoading === true) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-56b7b993!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/duplicateRoundtableModal/duplicateRoundtableModal.vue
// module id = 958
// module chunks = 61